import { useContext } from "react";

import Multimedia from "@components/shared/multimedia";

import { ExternalButton } from "@sharedComponents/buttons";

import { StoreContext } from "@components/store/provider";
import { useWorkspaceContext } from "@contexts/workspace-context";

import { getStoreHomeRoute } from "@constants/routes";
import { NEED_HELP_URL } from "@stadium/constants/external-routes";
import { externalRoutes } from "@constants/external-routes";

import wavingGuy from "@assets/images/waving-guy.svg";

import styles from "./main.module.scss";

const CancelOrder = ({ orderNumber, isReOrderableOrder }) => {
  const { storeBasePath } = useContext(StoreContext);
  const { getDashboardUrlWithCurrentWorkspaceSlug } = useWorkspaceContext();

  return (
    <div className={styles.orderCancelBlock}>
      <div className={styles.title}>Your order #{orderNumber} has been canceled.</div>
      <div className={styles.info}>
        {isReOrderableOrder
          ? "If you'd like to reorder, you'll need to place an order through the order link again."
          : "Your order will be instantly refunded as Stadium Points."}
        <br />
        Have questions?{" "}
        <ExternalButton href={NEED_HELP_URL} className={styles.helpLink}>
          Get Help
        </ExternalButton>
      </div>
      <div className={styles.imageBlock}>
        <Multimedia
          type="image"
          src={wavingGuy}
          width={292}
          height={256}
          alt={"Waving Guy"}
          className={styles.mainImage}
        />
      </div>
      {isReOrderableOrder ? (
        <div className={styles.buttonsBlock}>
          <ExternalButton
            styleType="primary"
            href={getDashboardUrlWithCurrentWorkspaceSlug(externalRoutes.home())}
            className={styles.btnReturn}
          >
            Return to Home
          </ExternalButton>
        </div>
      ) : (
        <div className={styles.buttonsBlock}>
          <ExternalButton
            styleType="primary"
            href={getStoreHomeRoute({ storeBasePath })}
            className={styles.btnReturn}
          >
            Return to Shop
          </ExternalButton>
        </div>
      )}
    </div>
  );
};

export default CancelOrder;
